const footerColumns = [
  {
    title: '内容导航',
    links: [
      { label: '情报速览', href: '#hero' },
      { label: '个人资料', href: '#profile' },
      { label: '热搜话题墙', href: '#topics' },
      { label: '最新爆料', href: '#leaks' },
    ],
  },
  {
    title: '精选合集',
    links: [
      { label: '造型变化全集', href: '#collections' },
      { label: '访谈金句合集', href: '#collections' },
      { label: '争议时间线', href: '#collections' },
      { label: '同框合照索引', href: '#collections' },
    ],
  },
  {
    title: '站内须知',
    links: [
      { label: '内容来源说明', href: '#profile' },
      { label: '社区发言规范', href: '#community' },
      { label: '纠错与补充', href: '#comments' },
      { label: '免责声明', href: '#profile' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" aria-hidden="true" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-base font-bold text-background-50">风间由美</span>
                <span className="font-label text-[10px] tracking-[0.28em] text-accent-400">情报总站</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-background-300">
              把风间由美的个人资料、近况、黑料与八卦爆料集中整理在一起，帮关注她的吃瓜网友省下去多个平台搜索的功夫。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['个人资料', '近况', '黑料', '八卦', '爆料'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-700 bg-secondary-800 px-2.5 py-1 text-[11px] text-background-200"
                >
                  # {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-xs text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-secondary-700 bg-secondary-800/60 p-4">
          <p className="text-[11px] leading-relaxed text-background-300">
            免责声明：本站为娱乐资讯聚合型展示站点，内容由网友根据公开讨论整理，仅供浏览与交流参考，不代表任何事实认定，也不构成对任何个人的评价。
            如相关内容涉及版权或信息有误，可通过社区留言反馈，我们会尽快核实处理。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-[11px] text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 风间由美情报总站 · 全网吃瓜情报聚合展示</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-accent-400" aria-hidden="true" />
            桌面端与移动端均已适配
          </p>
        </div>
      </div>
    </footer>
  );
}